import WebChat from "./webchat/page";

const App = () => {
  return (
    <div className="App">
      <WebChat />
    </div>
  );
}

export default App;
